import type { SortableCollectionListBaseProps } from '@/components/blocks/editor/collection/collection-dnd';
import type { CollectionMediaLayout } from '@/lib/blocks/collection/media-layout';
import { cn } from '@/lib/utils';
import { SortableCollectionCard } from './collection-card';

interface SortableGridListProps extends SortableCollectionListBaseProps {
  mediaLayout: CollectionMediaLayout;
  containerClassName: string;
}

export function SortableGridList({
  items,
  cardConfig,
  mediaLayout,
  cardPaddingClass,
  cardStyle,
  containerClassName,
  collectionSortableGroup,
  collectionItemDragData,
  disabled,
  actionsDisabled,
  selectedItemId,
  onUpdate,
  onDelete,
  onDuplicate,
  onSelectionChange,
}: SortableGridListProps) {
  return (
    <div className={cn('rounded-lg', containerClassName)}>
      {items.map((item, sortIndex) => (
        <SortableCollectionCard
          key={item.id}
          item={item}
          totalCount={items.length}
          sortIndex={sortIndex}
          collectionSortableGroup={collectionSortableGroup}
          collectionItemDragData={collectionItemDragData}
          cardConfig={cardConfig}
          mediaLayout={mediaLayout}
          paddingClassName={cardPaddingClass}
          cardStyle={cardStyle}
          disabled={disabled}
          actionsDisabled={actionsDisabled}
          onUpdate={onUpdate}
          onDelete={() => onDelete(item.id)}
          onDuplicate={() => onDuplicate(item.id)}
          primarySelected={selectedItemId === item.id}
          onSelectionChange={(selected) => onSelectionChange(item.id, selected)}
        />
      ))}
    </div>
  );
}
